import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Parts extends ChemComponent {
	constructor(props) {
		super(props);
		
		var search = {
			SHOP_ID: null,
			PART_NAME: '',
			CATEGORY_ID: null,
			ALT_DESC: '',
			MANUF_NUM: '',
			X_REF: '',
			VENDOR_PART: '',
			PART_ID: '',
			VENDOR_NAME: null,
			DATE_MODIF_FROM: null,
			DATE_MODIF_TO: null,
			ORDER_BY: ['PART_NAME']
		};
		
		var partListInit = this.copyTable(partList);
		partListInit.query.search = this.constructSearch(search);
		partListInit.query.order = search.ORDER_BY;

		this.state = {
			search: search,
			partList: partListInit,
			showSearch: false,
			searchCount: null,
			renderKey: 0
		};
	}
	
	addPart() {
		this.props.navigate('/Jobtrack/Parts/new');
	}
	
	editPart(partId) {
		this.props.setPartEditable(true);
		this.props.navigate('/Jobtrack/Parts/' + partId);
	}
	
	viewPart(partId) {
		this.props.setPartEditable(false);
		this.props.navigate('/Jobtrack/Parts/' + partId);
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search }, () => {
			if (accessor === 'PAGE_SEARCH') window.find(value);
		});
	}

	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: [{ Attribute: 'DELETE_FLAG', Operator: 'is null' }]
		};
		
		// maintain separate clause for part name since we will compare it to several different columns
		var pname_search = {
			Operator: 'or',
			Children: []
		};

		if (!this.isEmpty(data.SHOP_ID)) search.Children.push({ Attribute: 'SHOP_ID', Operator: '=', LongValue: data.SHOP_ID });
		if (!this.isEmpty(data.PART_NAME)) {
			// check if part_name starts with a number
			var partIDMatch = data.PART_NAME.match(/^([0-9]+)(?:\s|$)/);
			if (partIDMatch) {
				search.Children.push({ Attribute: 'PART_ID', Operator: '=', LongValue: partIDMatch[1] });
			} else {
				var like_pname = '%' + data.PART_NAME.toUpperCase() + '%';
				// compare all relevant text inputs to part name
				pname_search.Children.push({ Attribute: 'PART_NAME_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'MANUF_NUM_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'ALT_DESC_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'VENDOR_PART_UCASE', Operator: 'like', StringValue: like_pname });
				pname_search.Children.push({ Attribute: 'X_REF_UCASE', Operator: 'like', StringValue: like_pname });
				search.Children.push(pname_search);
			}
		}
		if (!this.isEmpty(data.CATEGORY_ID)) search.Children.push({ Attribute: 'CATEGORY_ID', Operator: '=', LongValue: data.CATEGORY_ID });
		if (!this.isEmpty(data.ALT_DESC)) { 
			search.Children.push({ Attribute: 'ALT_DESC_UCASE', Operator: 'like', StringValue: '%' + data.ALT_DESC.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.MANUF_NUM)) {
			search.Children.push({ Attribute: 'MANUF_NUM_UCASE', Operator: 'like', StringValue: '%' + data.MANUF_NUM.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.X_REF)) {
			search.Children.push({ Attribute: 'X_REF_UCASE', Operator: 'like', StringValue: '%' + data.X_REF.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.VENDOR_PART)) {
			search.Children.push({ Attribute: 'VENDOR_PART_UCASE', Operator: 'like', StringValue: '%' + data.VENDOR_PART.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.VENDOR_NAME)) {
			search.Children.push({ Attribute: 'VENDOR_NAME_UCASE', Operator: 'like', StringValue: '%' + data.VENDOR_NAME.toUpperCase() + '%' });
		}
		if (!this.isEmpty(data.DATE_MODIF_FROM)) {
			search.Children.push({ Attribute: 'DATE_MODIF', Operator: '>=', DateValue: data.DATE_MODIF_FROM });
		}
		if (!this.isEmpty(data.DATE_MODIF_TO)) {
			// add 1 day
			var modifDateTo = this.getDate(data.DATE_MODIF_FROM);
			modifDateTo.setDate(modifDateTo.getDate() + 1);
			search.Children.push({ Attribute: 'DATE_MODIF', Operator: '<', DateValue: this.dateTimeToMVC(modifDateTo) });
		}

		return search;
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		var newPartList = this.copyTable(partList);
		newPartList.query.search = this.constructSearch(search);
		if (newOrderBy) {
			search.ORDER_BY = newOrderBy;
			newPartList.query.order = newOrderBy;
		}
		
		this.mergeState({
			search: search,
			partList: newPartList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Parts',
			columns: exportColumns,
			entity: 'RECHARGES.PARTS_VW',
			search: this.constructSearch(this.state.search),
			order: this.state.search.ORDER_BY
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Shops Parts</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={partSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Parts' table={this.state.partList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const partSearch = [
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 0, col: 0,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.PART_SHOP_SELECT_VW', order: 'SHOP_NAME' }},
	{ Header: 'Part Name', accessor: 'PART_NAME', row: 0, col: 1 },
	{ Header: 'Category/Keyword', accessor: 'CATEGORY_ID', row: 0, col: 2,
		options: { value: 'CATEGORY_ID', label: 'CATEGORY_NAME', entity: 'RECHARGES.PART_CATEGORY_SELECT_VW', order: 'CATEGORY_NAME_SORT' }},
	{ Header: 'Alt Desc', accessor: 'ALT_DESC', row: 1, col: 0 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', row: 1, col: 1 },
	{ Header: 'Cross Reference', accessor: 'X_REF', row: 1, col: 2 },
	{ Header: 'Vendor Part', accessor: 'VENDOR_PART', row: 2, col: 0 },
	{ Header: 'ID', accessor: 'PART_ID', row: 2, col: 1 },
	{ Header: 'Vendor Name', accessor: 'VENDOR_NAME', type: 'select', row: 2, col: 2,
		options: { value: 'VENDOR_NAME', label: 'VENDOR_NAME', entity: 'RECHARGES.SHOP_PART', distinct: true, order: 'VENDOR_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
				{ Attribute: 'VENDOR_NAME', Operator: 'is not null' }
	]}}},
	{ Header: 'Last Updated From', accessor: 'DATE_MODIF_FROM', type: 'date', row: 3, col: 0 },
	{ Header: 'Last Updated To', accessor: 'DATE_MODIF_TO', type: 'date', row: 3, col: 1 }
];

const partList = {
	query: { entity: 'RECHARGES.PARTS_VW', search: null, order: 'PART_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addPart()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editPart(props.row.values.PART_ID)} /> },
		{ Header: 'ID', accessor: 'PART_ID', width: 60,
			Cell: props => <HashLink onClick={() => props.parent.viewPart(props.value)}>{props.value}</HashLink> },
		{ Header: 'Shop', accessor: 'SHOP_NAME', width: 100 },
		{ Header: 'Category', accessor: 'CATEGORY_NAME', width: 125 },
		{ Header: 'Part Name', accessor: 'PART_NAME', width: 300 },
		{ Header: 'Alt. Desc', accessor: 'ALT_DESC', width: 125 },
		{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', width: 60 },
		{ Header: 'Recharge Cost', accessor: 'UNIT_COST', width: 80 },
		{ Header: 'Vendor', accessor: 'VENDOR_NAME', width: 125 },
		{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', width: 125 },
		{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', width: 75 },
		{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', width: 75 },
		{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', width: 75 },
		{ Header: 'Cross Reference', accessor: 'X_REF', width: 125 },
		{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', width: 125 },
		{ Header: 'Comments', accessor: 'COMMENTS', width: 400 },
		{ Header: 'Inventory', accessor: 'STOCK_QTY', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'PART_ID', width: 12 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 20 },
	{ Header: 'Category', accessor: 'CATEGORY_NAME', width: 25 },
	{ Header: 'Part Name', accessor: 'PART_NAME', width: 60 },
	{ Header: 'Alt. Desc', accessor: 'ALT_DESC', width: 25 },
	{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', width: 12 },
	{ Header: 'Recharge Cost', accessor: 'UNIT_COST', width: 16 },
	{ Header: 'Vendor', accessor: 'VENDOR_NAME', width: 25 },
	{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', width: 25 },
	{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', width: 15 },
	{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', width: 15 },
	{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', width: 15 },
	{ Header: 'Cross Reference', accessor: 'X_REF', width: 25 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', width: 25 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 80 },
	{ Header: 'Inventory', accessor: 'STOCK_QTY', width: 20 }
];

export default withRouter(Parts);
